import produce from "immer";
import forEach from "lodash/forEach";
import { v1 as uuid } from "uuid";
import { CustomizationState } from "..";
import { getCoverFilteredPages, getNoCoverDefinitions } from "../../../utils/customization/cover";
import { changeOnePagePageDefinition } from "../../../utils/customization/pageDefinition";
import { addNotificationRemovingSameOnes } from "../../../utils/notification";

export interface ChangeAllPagesPageDefinitionAction {
  type: "changeAllPagesPageDefinition";
  pageDefinitionKey: string;
}

export function changeAllPagesPageDefinition(
  state: CustomizationState,
  action: ChangeAllPagesPageDefinitionAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { content, template } = draftState;

    let hasLostText = false;
    const noCoverDefinitions = getNoCoverDefinitions(template.pageDefinitions);
    const noCoverPages = getCoverFilteredPages(content.pages, noCoverDefinitions);
    forEach(noCoverPages, (page) => {
      const { hasLoss } = changeOnePagePageDefinition(page, draftState, action.pageDefinitionKey);
      hasLostText = hasLoss || hasLostText;
    });

    if (hasLostText) {
      addNotificationRemovingSameOnes(draftState.notifications, {
        code: "KFW-001",
        key: uuid(),
      });
    }
  });
}
